import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { SessionService } from '../../../services/session.service';

import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';
import { ELEMENT_PROBE_PROVIDERS } from '@angular/platform-browser/src/dom/debug/ng_probe';

@Component({
  selector: 'app-arqueo-caja-add',
  templateUrl: './arqueo-caja-add.component.html',
  styleUrls: ['./arqueo-caja-add.component.css']
})

export class ArqueoCajaAddComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/arqueo-caja-add/arqueo-caja-add.component.ts